<script lang="ts" setup>
const accountStore = useAccountStore()
const { t } = useLang()

withDefaults(
  defineProps<{
    subaccountId?: string
  }>(),
  {
    subaccountId: ''
  }
)

const emit = defineEmits<{
  'update:subaccountId': [state: string]
}>()

const sortedSubaccountIds = computed(() =>
  Object.keys(accountStore.accountBalancesMap).sort()
)

const subaccountIdsWithDisplay = computed(() =>
  sortedSubaccountIds.value.map((value, index) => ({
    value,
    display:
      index === 0
        ? `${t('account.bank')} + ${t('account.tradingAccount')} 0`
        : `${t('account.tradingAccount')} ${index}`
  }))
)

// Show only trading accounts which have some balances
const filteredSubaccountIdsWithDisplay = computed(() =>
  subaccountIdsWithDisplay.value.filter(
    (subaccountId) =>
      accountStore.accountBalancesMap[subaccountId.value].length > 0
  )
)

function onChange(value: string) {
  emit('update:subaccountId', value)
}
</script>

<template>
  <AppSelector
    :model-value="subaccountId"
    v-bind="{ options: filteredSubaccountIdsWithDisplay }"
    @update:model-value="onChange"
  />
</template>
